<template>
  <page-layout-full class="ai-widget-view" view="sm">
    <template #title> Тест готового виджета Яндекса </template>

    <template #subtitle>
      Виджет чата Yandex AI Studio. Подключается своим скриптом, весь диалог
      обрабатывается на стороне Яндекса.
    </template>

    <base-alert v-if="!src" view="warning">
      Скрипт виджета не задан: нужен адрес widget-loader.js с channel-id из
      Yandex AI Studio.
    </base-alert>

    <div class="ai-widget-view__container">
      <p class="ai-widget-view__placeholder">
        {{
          src
            ? "Кнопка виджета — в правом нижнем углу страницы"
            : "Здесь появится виджет"
        }}
      </p>
    </div>
  </page-layout-full>
</template>

<script>
import PageLayoutFull from "@/components/page/PageLayoutFull.vue";
import BaseAlert from "@/components/shared/BaseAlert.vue";

export default {
  components: {
    PageLayoutFull,
    BaseAlert,
  },
  data() {
    return {
      src:
        process.env.VUE_APP_YANDEX_AI_WIDGET_SRC ||
        "https://widget.aistudio.yandexcloud.net/scripts/widget-loader.js?channel-id=aacaniqikaqnkm59lphv",
      scriptId: "yandex-ai-widget-script",
    };
  },
  mounted() {
    this.onLoadWidget();
  },
  beforeDestroy() {
    // кнопка и окно виджета живут в body — без destroy() останутся на других страницах
    if (window.AiStudioChatWidget) window.AiStudioChatWidget.destroy();

    const script = document.getElementById(this.scriptId);
    if (script) script.remove();
  },
  methods: {
    onLoadWidget() {
      if (!this.src || document.getElementById(this.scriptId)) return;

      const script = document.createElement("script");
      script.id = this.scriptId;
      script.src = this.src;
      script.async = true;
      script.dataset.locale = "ru";
      script.onerror = () => {
        this.$toast.error("Не удалось загрузить скрипт виджета.");
      };

      document.body.appendChild(script);
    },
  },
};
</script>

<style lang="scss" scoped>
.ai-widget-view {
  &__container {
    border: 1px dashed $grey-300;
    border-radius: 8px;
    min-height: 460px;
    padding: 1rem;
    position: relative;
  }

  &__placeholder {
    color: $stone;
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
